import React, { useEffect, useState } from 'react'
import Header from '../Component/Header'
import Footer from '../Component/Footer'
import { Link } from 'react-router-dom';

function Services({ serviceId, servicename }) {
    const [services, setServices] = useState([]); // State to store services
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [openFAQ, setOpenFAQ] = useState(null);
    const toggleFAQ = (index) => {
        setOpenFAQ(openFAQ === index ? null : index);
    };

    const [expandedReviews, setExpandedReviews] = useState({});

    const toggleReview = (index) => {
        setExpandedReviews(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const getShortText = (text) => text.substring(0, 70) + "...";

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/getcategories`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const result = await response.json();

                // Transform the fetched data to match your services structure
                const transformedData = result.data.map((item) => ({
                    id: item.id,
                    name: item.category,
                    image: `${item.categoryIcon}`, // Prepend the image URL from the environment variable
                }));

                setServices(transformedData);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchServices();
    }, []);

    return (
        <>
            <Header />
            <div style={{ backgroundColor: "#FFFFFF" }}>
                {/* Service Start */}
                <div className="container-xxl py-4 my-1">
                    <div className="container py-5"></div>
                    <div
                        className="text-center mx-auto mb-5 wow fadeInUp"
                        data-wow-delay="0.1s"
                        style={{ maxWidth: 500 }}
                    >
                        <p className="display-6 text-black text-uppercase mb-2">PORTFOLIO</p>
                    </div>

                    {loading && <p className="text-center">Loading services...</p>}
                    {error && <p className="text-center text-danger">{error}</p>}

                    {!loading && !error && (
<div className="row g-4">
    {services.map((service) => (
        <div
            key={service.id}
            className="col-12 col-sm-6 col-lg-3" 
        >
            <Link
                to={`/service/${service.id}/${service.name}`}
                className="text-decoration-none"
            >
                <div
                    className="service-item d-flex flex-column p-3 pb-0"
                    style={{ backgroundColor: "#ffffffff", borderRadius: "10px" }}
                >
                    <div
                        className="position-relative"
                        style={{ height: "250px", overflow: "hidden" }}
                    >
                        <img
                            className="img-fluid"
                            src={service.image}
                            alt={service.name}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                    </div>
                    <div className="text-center p-3">
                        <h4>{service.name}</h4>
                    </div>
                </div>
            </Link>
        </div>
    ))}
</div>

                    )}
                </div>

                {/* --------------------- FAQ SECTION --------------------- */}

                <div className="container-xxl py-5">
                    <div className="container">

                        <h2 className="mb-5" style={{ fontSize: "32px", fontWeight: 600 }}>
                            Frequently Asked Questions
                        </h2>

                        {/* FAQ Item 1 */}
                        <div className="mb-4">
                            <div
                                onClick={() => toggleFAQ(1)}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    fontWeight: 600,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                Services
                                <span
                                    style={{
                                        transition: "0.3s",
                                        transform: openFAQ === 1 ? "rotate(180deg)" : "rotate(0deg)",
                                        fontSize: "22px"
                                    }}
                                >
                                    ▼
                                </span>
                            </div>
                            <hr />
                            {openFAQ === 1 && (
                                <div className="mt-3">
                                    <p><strong>What types of products do you shoot?</strong></p>
                                    <p>We cover all categories including product, jewellery, food & beverages, garments, industrial products, and factory environments.</p>
                                    <br></br>

                                    <p><strong>Do you handle end-to-end production?</strong></p>
                                    <p>Yes. From concept and moodboard to styling, models, makeup artist, photography, videography, and editing—we manage the complete process.</p>
                                </div>
                            )}
                        </div>

                        {/* FAQ Item 2 */}
                        <div className="mb-4">
                            <div
                                onClick={() => toggleFAQ(2)}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    fontWeight: 600,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                Pricing & Booking
                                <span
                                    style={{
                                        transition: "0.3s",
                                        transform: openFAQ === 2 ? "rotate(180deg)" : "rotate(0deg)",
                                        fontSize: "22px"
                                    }}
                                >
                                    ▼
                                </span>
                            </div>
                            <hr />
                            {openFAQ === 2 && (
                                <div className="mt-3">
                                    <p><strong>We offer two pricing models:</strong></p>
                                    <p>Hourly Basis: 4 hrs (₹12,000) / 8 hrs (₹20,000). Extended hours (10–12 hrs) available on request</p>
                                    <p>Per Photo Basis: Based on product type, number of products, and expected final output.</p>
                                    <br></br>

                                    <p>To recommend the best option, we request:</p>
                                    <p>Basic mobile photos of your product</p>
                                    <p>Reference images (screenshots are fine, no links)</p>
                                    <br></br>

                                    <p><strong>Do you provide discounts for bulk shoots?</strong></p>
                                    <p>Yes, we can create custom packages for large-volume projects once we understand your requirements.</p>
                                    <br></br>

                                    <p><strong>How do I book a shoot?</strong></p>
                                    <p>Send confirmation via email with billing details</p>
                                    <p>Share brief, references, and moodboard in advance</p>
                                    <p>Book dates 6–10 working days prior to the shoot</p>
                                    <p>Pay 60% advance to confirm dates (non-refundable if changes are made from your side)</p>
                                    <p>Remaining 40% is payable upon completion of the shoot</p>
                                </div>
                            )}
                        </div>

                        {/* FAQ Item 3 */}
                        <div className="mb-4">
                            <div
                                onClick={() => toggleFAQ(3)}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    fontWeight: 600,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                Shoot Process
                                <span
                                    style={{
                                        transition: "0.3s",
                                        transform: openFAQ === 3 ? "rotate(180deg)" : "rotate(0deg)",
                                        fontSize: "22px"
                                    }}
                                >
                                    ▼
                                </span>
                            </div>
                            <hr />
                            {openFAQ === 3 && (
                                <div className="mt-3">
                                    <p><strong>Do you shoot only at your studio?</strong></p>
                                    <p>No.</p>
                                    <br></br>

                                    <p>Studio – Best suited for product, food, and jewellery shoots</p>
                                    <p>On-site – Industrial and factory projects (we travel worldwide)</p>
                                    <br></br>

                                    <p><strong>Do you provide props and styling?</strong></p>
                                    <p>Yes. We work with an associate stylist who can arrange props and styling as per your requirements. You are also welcome to arrange your own props and stylist.</p>
                                    <br></br>

                                    <p><strong>Are editing and retouching included in the price?</strong></p>
                                    <p>Routine shoot prices do not include editing. For per-photo pricing, editing and retouching can be included on request.</p>
                                </div>
                            )}
                        </div>

                        {/* FAQ Item 4 */}
                        <div className="mb-4">
                            <div
                                onClick={() => toggleFAQ(4)}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    fontWeight: 600,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                Deliverables
                                <span
                                    style={{
                                        transition: "0.3s",
                                        transform: openFAQ === 4 ? "rotate(180deg)" : "rotate(0deg)",
                                        fontSize: "22px"
                                    }}
                                >
                                    ▼
                                </span>
                            </div>
                            <hr />
                            {openFAQ === 4 && (
                                <div className="mt-3">
                                    <p><strong>How long will it take to deliver the photos?</strong></p>
                                    <p>48 hours – Simple white background product photography</p>
                                    <p>Up to 25 days – Full project including moodboard, pre-production, styling, photoshoot, and editing Emergency delivery can be arranged if required.</p>
                                    <br></br>

                                    <p><strong>How many photos will I get per product?</strong></p>
                                    <p>This depends on your usage and requirements. After discussing your project, we’ll guide you on the ideal number of images.</p>
                                    <br></br>

                                    <p><strong>What do I receive after the shoot?</strong></p>
                                    <p>Low-resolution, watermarked JPEGs for proofing within 3–5 days</p>
                                    <p>High-resolution RAW and JPEG files (via HDD or download link) after full payment</p>
                                </div>
                            )}
                        </div>

                        {/* FAQ Item 5 */}
                        <div className="mb-4">
                            <div
                                onClick={() => toggleFAQ(5)}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    fontWeight: 600,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                Usage & Rights
                                <span
                                    style={{
                                        transition: "0.3s",
                                        transform: openFAQ === 5 ? "rotate(180deg)" : "rotate(0deg)",
                                        fontSize: "22px"
                                    }}
                                >
                                    ▼
                                </span>
                            </div>
                            <hr />
                            {openFAQ === 5 && (
                                <div className="mt-3">
                                    <p><strong>Can I use the photos across different platforms?</strong></p>
                                    <p>Yes. Photos can be used for websites, e-commerce platforms, social media, and print. Please inform us in advance so we can plan accordingly.</p>
                                    <br></br>

                                    <p><strong>Who owns the rights to the photos?</strong></p>
                                    <p>The final images are the exclusive property of the client/agency</p>
                                    <p>Images can be used across any medium, for unlimited duration</p>
                                    <p>We may showcase selected images in our portfolio with proper client credit</p>
                                </div>
                            )}
                        </div>

                        {/* FAQ Item 6 */}
                        <div className="mb-4">
                            <div
                                onClick={() => toggleFAQ(6)}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    fontWeight: 600,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                Quality & Revisions
                                <span
                                    style={{
                                        transition: "0.3s",
                                        transform: openFAQ === 6 ? "rotate(180deg)" : "rotate(0deg)",
                                        fontSize: "22px"
                                    }}
                                >
                                    ▼
                                </span>
                            </div>
                            <hr />
                            {openFAQ === 6 && (
                                <div className="mt-3">
                                    <p><strong>Do you provide revisions if we want changes?</strong></p>
                                    <p>We work on detailed briefs and references in advance to avoid errors. If a reshoot is required, it will be chargeable. </p>
                                </div>
                            )}
                        </div>

                        {/* FAQ Item 7 */}
                        <div className="mb-4">
                            <div
                                onClick={() => toggleFAQ(7)}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    fontWeight: 600,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                Terms & Conditions
                                <span
                                    style={{
                                        transition: "0.3s",
                                        transform: openFAQ === 7 ? "rotate(180deg)" : "rotate(0deg)",
                                        fontSize: "22px"
                                    }}
                                >
                                    ▼
                                </span>
                            </div>
                            <hr />
                            {openFAQ === 7 && (
                                <div className="mt-3">
                                    <p><strong>Working Hours & Charges</strong></p>
                                    <p>Standard workday: 8 hours</p>
                                    <p>Additional hours billed at 1.5x the hourly rate</p>
                                    <p>Studio maintenance charge: ₹2,000 (per 8 hrs)</p>
                                    <p>Food, travel, and accommodation must be provided by the client</p>
                                    <br></br>

                                    <p><strong>Additional Terms</strong></p>
                                    <p>All belongings must be collected from the studio within 3 working days after the shoot</p>
                                    <p>Quotations are valid for 45 days</p>
                                    <p>Pricing mentioned applies to Ahmedabad shoots only (travel costs apply for other locations)</p>
                                </div>
                            )}
                        </div>

                    </div>
                </div>

                {/* =================== GOOGLE REVIEW SECTION =================== */}

                <div className="container-xxl py-5">
                    <div className="container">

                        {/* Header */}
                        <div
                            className="d-flex justify-content-between align-items-center p-4"
                            style={{ backgroundColor: "#f4f4f4", borderRadius: "15px" }}
                        >
                            <div>
                                <h3 style={{ fontWeight: "600" }}>Google Reviews</h3>
                                <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "22px", fontWeight: "700" }}>4.9</span>
                                    <span className="ms-2" style={{ color: "#f4b400", fontSize: "20px" }}>★★★★★</span>
                                    {/* <span className="ms-2 text-muted">(150)</span> */}
                                </div>
                            </div>

                            <a
                                href="https://g.page/r/CZZHIqMwS3RjEAE/review"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    padding: "10px 20px",
                                    borderRadius: "10px",
                                    border: "1px solid #000",
                                    background: "#fff",
                                    fontWeight: "600",
                                    textDecoration: "none",
                                    color: "black",
                                    display: "inline-block"
                                }}
                            >
                                Review us on Google
                            </a>
                        </div>

                        {/* Review Cards */}
                        {/* <div className="row mt-4 g-4">

                            {[
                                {
                                    name: "infozynore",
                                    fullText: "I had a great experience with the photography. The food and jewellery shots were amazing and professionally clicked."
                                },
                                {
                                    name: "Patel Rutvik",
                                    fullText: "Amazing work! The product photos came out super clean, bright, and sharp. Excellent experience overall."
                                },
                                {
                                    name: "Vraj Thakkar",
                                    fullText: "I am super happy with the product photography. Highly recommended for commercial shoots."
                                },
                                {
                                    name: "Kush Patel",
                                    fullText: "Not just an ordinary photographer—he is highly skilled and extremely creative. You will definitely love the output."
                                },
                                {
                                    name: "Bhoomi Zinzuvadiya",
                                    fullText: "Very nice work and great attention to detail. Highly recommended for professional photoshoots."
                                },
                                {
                                    name: "Zaan Patel",
                                    fullText: "You are at the perfect place if you want commercial photography with excellent finishing and style."
                                }
                            ].map((review, index) => {

                                const isExpanded = expandedReviews[index] || false;
                                const text = isExpanded ? review.fullText : getShortText(review.fullText);

                                return (
                                    <div className="col-12 col-sm-6 col-lg-4" key={index}>
                                        <div
                                            style={{
                                                backgroundColor: "#f4f4f4",
                                                padding: "25px",
                                                borderRadius: "15px",
                                                minHeight: "200px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between"
                                            }}
                                        >
                                            <div>
                                                <div style={{ color: "#f4b400", fontSize: "18px" }}>★★★★★</div>

                                                <p style={{
                                                    fontSize: "15px",
                                                    marginTop: "10px",
                                                    color: "#444",
                                                    lineHeight: "1.4"
                                                }}>
                                                    {text}
                                                    <span
                                                        onClick={() => toggleReview(index)}
                                                        style={{
                                                            color: "#000",
                                                            cursor: "pointer",
                                                            fontWeight: "600",
                                                            marginLeft: "5px"
                                                        }}
                                                    >
                                                        {isExpanded ? "Read less" : "Read more"}
                                                    </span>
                                                </p>
                                            </div>

                                            <div>
                                                <h6 style={{ marginTop: "10px", fontWeight: "600" }}>
                                                    {review.name}
                                                </h6>
                                                <p className="text-muted" style={{ fontSize: "13px", margin: 0 }}>
                                                    Posted on Google
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                        </div> */}
                    </div>
                </div>

                <Footer />
            </div>
        </>
    )
}

export default Services